import * as React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import "./libs/sentry/init";

import config, { assertConfig } from "./config";

import "./styles";

import "./debug";
import store from "./redux/storeInstance";
import Router from "./react/Router";
import { SentryBoundary } from "./hoc/ErrorBoundary";

window.addEventListener("load", () => {
  const el = document.createElement("div");
  el.className = "mainWrapper";
  document.body.appendChild(el);
  if (config.favicon) {
    createFaviconEl(config.favicon);
  }

  const root = createRoot(el);

  try {
    assertConfig(config);
    root.render(
      <SentryBoundary>
        <Provider store={store}>
          <Router />
        </Provider>
      </SentryBoundary>,
    );
  } catch (e) {
    root.render(<div>{e.message}</div>);
  }
});

function createFaviconEl(iconUrl: string) {
  const headEl = document.getElementsByTagName("head")[0];
  const linkEl = document.createElement("link");
  linkEl.setAttribute("rel", "shortcut icon");
  linkEl.setAttribute("sizes", "16x16 32x32 128x128 256x256");
  linkEl.setAttribute("href", iconUrl);
  headEl.appendChild(linkEl);
  return linkEl;
}
